var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gadget-description"},[_c('el-row',[_c('el-col',[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.tools['googleCv'].name2)+"とは")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }